export const keys = {
    all: ["tank-battery-summary"],
    summaryDatas: () => [
        ...keys.all,
        "summary-data"
    ],
    summaryData: (customerID: number, groupID: number, offline: boolean) => [
        ...keys.summaryDatas(),
        {
            customerID,
            groupID,
            offline
        }
    ]
};
